var _rect, _ellipse, _path, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedditTile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ff4500",
    height: 512,
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 305,
    fill: "#fff",
    rx: 177,
    ry: 123
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199 347c35 29 79 29 114 0l12 11c-42 35-96 35-138 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 285,
    r: 28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 285,
    r: 28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 125,
    r: 28,
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 22,
    d: "M87 282c-45-22-5-92 40-50m298 50c45-22 5-92-40-50m-127-45l24-83 80 16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedditTile);
export default __webpack_public_path__ + "static/media/reddit-tile.3710839eba002ab605dc1ad41701e4d6.svg";
export { ForwardRef as ReactComponent };